import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { SITE, SERVICES } from "../lib/site";

const Footer = () => (
  <footer className="bg-navy text-slate-300" data-testid="main-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-white/10">
        <div>
          <p className="font-display text-2xl font-black text-white tracking-tight">
            RICHIE <span className="text-gold">RICH</span>
          </p>
          <p className="mt-4 text-sm leading-relaxed text-slate-400">
            An IT company based in Delhi, India — engineering enterprise-grade web, mobile, cloud and security
            solutions for businesses that mean business.
          </p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-gold">Company</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link to="/" data-testid="footer-link-home" className="hover:text-white transition-colors">Home</Link></li>
            <li><Link to="/about" data-testid="footer-link-about" className="hover:text-white transition-colors">About Us</Link></li>
            <li><Link to="/services" data-testid="footer-link-services" className="hover:text-white transition-colors">Services</Link></li>
            <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-white transition-colors">Contact Us</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-gold">Services</p>
          <ul className="mt-5 space-y-3 text-sm">
            {SERVICES.slice(0, 5).map((s) => (
              <li key={s.id}>
                <Link to="/services" data-testid={`footer-service-${s.id}`} className="hover:text-white transition-colors">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-gold">Contact</p>
          <ul className="mt-5 space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-0.5 shrink-0 text-gold" />
              <span data-testid="footer-address">{SITE.address}</span>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={16} className="mt-0.5 shrink-0 text-gold" />
              <a href={`tel:+${SITE.phoneRaw}`} data-testid="footer-phone" className="hover:text-white transition-colors">
                {SITE.phoneDisplay}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="mt-0.5 shrink-0 text-gold" />
              <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="hover:text-white transition-colors">
                {SITE.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="text-center md:text-left">
          <p className="font-display font-bold text-white text-base sm:text-lg tracking-wide" data-testid="footer-copyright">
            © 2026 <span className="text-gold">RICHIE RICH</span> All Rights Reserved
          </p>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-2 text-sm text-slate-400">
          <Link to="/privacy-policy" data-testid="footer-privacy-link" className="hover:text-gold transition-colors">
            Privacy Policy
          </Link>
          <span className="text-slate-600">|</span>
          <Link to="/terms-of-services" data-testid="footer-terms-link" className="hover:text-gold transition-colors">
            Terms of Services
          </Link>
          <span className="text-slate-600">|</span>
          <a href={`mailto:${SITE.email}`} data-testid="footer-email-bottom" className="hover:text-gold transition-colors">
            {SITE.email}
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
